import gql from 'graphql-tag';
import { USER_INFO_FRAGMENT } from '../user/fragment';
import {
  MINIMAL_BUSINESS_FRAGMENT,
  BUSINESS_DETAILS_FRAGMENT,
} from './fragment';

export const CHANGE_BUSINESS_STATUS = gql`
  mutation ChangeBusinessStatus($input: ChangeBusinessStatusInput!) {
    changeBusinessStatus(input: $input) {
      ...BusinessInfo
    }
  }
  ${MINIMAL_BUSINESS_FRAGMENT}
`;

export const CREATE_BUSINESS = gql`
  mutation CreateBusiness($input: CreateBusinessInput!) {
    createBusiness(input: $input) {
      ...BusinessInfo
      apa {
        ...UserInfo
      }
      mandatary {
        ...UserInfo
      }
    }
  }
  ${MINIMAL_BUSINESS_FRAGMENT}
  ${USER_INFO_FRAGMENT}
`;

export const UPDATE_BUSINESS = gql`
  mutation UpdateBusiness($input: UpdateBusinessInput!) {
    updateBusiness(input: $input) {
      ...BusinessDetailsInfo
    }
  }
  ${BUSINESS_DETAILS_FRAGMENT}
`;

export const CHANGE_BUSSINESS_DATES = gql`
  mutation ChangeBusinessDates($input: ChangeBusinessDatesInput) {
    changeBusinessDates(input: $input) {
      ...BusinessDetailsInfo
    }
  }

  ${BUSINESS_DETAILS_FRAGMENT}
`;

export const CHANGE_BUSSINESS_ESTIMATIONS = gql`
  mutation ChangeBusinessEstimations($input: ChangeBusinessEstimationsInput) {
    changeBusinessEstimations(input: $input) {
      ...BusinessDetailsInfo
    }
  }

  ${BUSINESS_DETAILS_FRAGMENT}
`;
